import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../../../constants/path';
import { HAS_INSTANT_DISCOUNT, USE_PARITY } from '../../../../../constants/ebon';

import { hasCashback } from '../../../../../services/partner/utils';
import { formatAmountCurrency, formatAmountParity } from '../../../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../../../utils/htmlUtils';

import LinkButtonComponent from '../../../../button/LinkButtonComponent';

import './ConfirmationEbonPageMessageBlocStyle.scss';

const FreeValueBloc = ({
    partner,
    isEnterpriseCard,
    sessionEmail,
    amount,
    isCumulableWithCashback,
    cumulableCashback,
    i18n,
    BRAND_NAME
}) => {
    const cashbackAmount = USE_PARITY ? formatAmountParity(amount) : formatAmountCurrency(amount);

    return (
        <div>
            <h1>{i18n.TITLE}</h1>

            {isEnterpriseCard && (
                <div className="enterprise-card-confirmation">
                    <h4>
                        {convertHtmlToReactDomWithParams(i18n.ENTERPRISE_CARD_TEXT_1, partner.name)}
                    </h4>
                    <p>
                        {convertHtmlToReactDomWithParams(i18n.ENTERPRISE_CARD_TEXT_2, BRAND_NAME)}
                    </p>
                </div>
            )}

            <div id="message-container">
                <h3>{i18n.FREE_FACIAL_VALUE.TEXT_1}</h3>
                <p>
                    {convertHtmlToReactDomWithParams(i18n.FREE_FACIAL_VALUE.TEXT_2, sessionEmail)}
                </p>
                <p>{i18n.FREE_FACIAL_VALUE.TEXT_3}</p>

                {!HAS_INSTANT_DISCOUNT && !!amount && amount > 0 && (
                    <p>
                        {convertHtmlToReactDomWithParams(
                            i18n.FREE_FACIAL_VALUE.TEXT_4,
                            cashbackAmount
                        )}
                    </p>
                )}

                {isCumulableWithCashback && hasCashback(partner) && (
                    <p>
                        {convertHtmlToReactDomWithParams(
                            i18n.FREE_FACIAL_VALUE.TEXT_5,
                            partner.name,
                            cumulableCashback
                        )}
                    </p>
                )}
            </div>

            {isEnterpriseCard && (
                <LinkButtonComponent
                    to={PATH.CASHBACK_EBON_MOST_POPULAR_PATH}
                    text={i18n.BUTTON_MOST_POPULAR}
                    title={i18n.BUTTON_MOST_POPULAR}
                    color="fifth"
                />
            )}
            <LinkButtonComponent
                to={PATH.ACCOUNT_EBONS_PATH}
                text={i18n.BUTTON}
                title={i18n.BUTTON}
                color="main"
            />
        </div>
    );
};

FreeValueBloc.propTypes = {
    partner: PropTypes.object,
    isEnterpriseCard: PropTypes.bool,
    sessionEmail: PropTypes.string,
    amount: PropTypes.number,
    isCumulableWithCashback: PropTypes.bool,
    cumulableCashback: PropTypes.string
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON.CONFIRMATION,
        BRAND_NAME: state.i18n.common.BRAND_NAME
    };
};

export default connect(mapStateToProps)(FreeValueBloc);



// WEBPACK FOOTER //
// ./src/components/pages/ebon/confirmation/message/FreeValueBloc.js